import { render } from "./Language.vue?vue&type=template&id=364a62f0&scoped=true&ts=true"
import script from "./Language.vue?vue&type=script&lang=ts"
export * from "./Language.vue?vue&type=script&lang=ts"

import "./Language.vue?vue&type=style&index=0&id=364a62f0&lang=scss&scoped=true"

import exportComponent from "D:\\Users\\Sean\\Documents\\landiyun4.0\\ldcustomer\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-364a62f0"]])

export default __exports__